export default __webpack_public_path__ + "static/media/Synthesis.984da760.png";